<div>
  <p>
    <b>Situação</b>: {{registro.objeto.situacao}}
  </p>
  <p>
    <b>Ação</b>: {{registro.objeto.acao}}
  </p>
  <p ng-if="registro.dataRegistro">Data do Registro: {{registro.dataRegistro | date: 'dd/MM/yyyy'}}</p>
</div>
